import posthog from "posthog-js";

const token = import.meta.env.VITE_POSTHOG_TOKEN;
const host = import.meta.env.VITE_POSTHOG_HOST;

if (!token || !host) {
  console.warn(
    "[PostHog] Analytics is disabled: VITE_POSTHOG_TOKEN and VITE_POSTHOG_HOST environment variables must be set."
  );
} else if (!posthog.__loaded) {
  posthog.init(token, {
    api_host: host,
    capture_exceptions: true,
    autocapture: true,
    capture_pageview: true,
  });
}

export function captureException(error: unknown): void {
  if (!posthog.__loaded) return;
  posthog.captureException(error);
}

export function captureEvent(event: string, properties?: Record<string, unknown>): void {
  if (!posthog.__loaded) return;
  posthog.capture(event, properties);
}

export function identifyUser(distinctId: string, properties?: Record<string, unknown>): void {
  if (!posthog.__loaded) return;
  posthog.identify(distinctId, properties);
}

export default posthog;
